import { Button, Stack, Typography } from "@mui/material"
import { useController, useForm } from "react-hook-form"
import { useDropboxChoose } from "./lib/useDropboxChoose"
import { DataSourceFormLayout } from "../../plugins/common/DataSourceFormLayout"
import {
  buildDataSourceSubmitPayload,
  getDataSourceFormBaseDefaults,
} from "../../plugins/common/dataSourceFormHelpers"
import type { DropboxDataSourceDocType } from "@oboku/shared"
import type {
  DataSourceFormData,
  DataSourceFormInternalProps,
} from "../../plugins/types"

type DropboxFormData = DataSourceFormData<{
  folderId: string
}>

export const DataSourceForm = ({
  dataSource,
  onSubmit,
  submitLabel,
}: DataSourceFormInternalProps<DropboxDataSourceDocType>) => {
  // react-hook-form is on React Compiler's incompatible-library list.
  // TODO: drop this opt-out once React Compiler handles react-hook-form, and verify the form still tracks state correctly.
  "use no memo"

  const { control, handleSubmit } = useForm<DropboxFormData>({
    mode: "onChange",
    defaultValues: {
      ...getDataSourceFormBaseDefaults(dataSource),
      folderId: dataSource?.data_v2?.folderId ?? "",
    },
  })
  const {
    field: { onChange, value: folderId },
  } = useController({
    control,
    rules: { required: false },
    name: "folderId",
  })
  const { choose } = useDropboxChoose({
    onSuccess: (files) => {
      const id = files[0]?.id

      onChange(id)
    },
  })

  return (
    <DataSourceFormLayout
      control={control}
      onSubmit={handleSubmit((data) =>
        onSubmit(
          buildDataSourceSubmitPayload(data, { folderId: data.folderId }),
        ),
      )}
      submitLabel={submitLabel}
    >
      <Stack
        sx={{
          gap: 1,
        }}
      >
        <Button
          variant="outlined"
          fullWidth
          onClick={() => choose({ select: "folder" })}
        >
          Choose a folder
        </Button>
        <Typography noWrap>Selected: {folderId || "None"}</Typography>
      </Stack>
    </DataSourceFormLayout>
  )
}
